import gql from 'graphql-tag';

export const QUERY_LANDLORDS = gql`
  query queryLandlords(
    $slugs: [NonEmptyString]
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $sortBy: LandlordSortBy
    $sortDirection: SortDirection
    $registerTypes: [LandlordRegisterType]
    $statuses: [LandlordStatus]
    $billingCountryIds: [ID]
    $accountManager: String
  ) {
    landlords(
      slugs: $slugs
      pageNumber: $pageNumber
      pageSize: $pageSize
      sortBy: $sortBy
      sortDirection: $sortDirection
      registerTypes: $registerTypes
      statuses: $statuses
      billingCountryIds: $billingCountryIds
      accountManager: $accountManager
    ) {
      edges {
        node {
          businessType
          firstName
          lastName
          governmentIssuedId
          billingAddress
          billingPostalCode
          billingCity {
            id
            name
          }
          billingCountry {
            id
            name
          }
          businessNumber
          pendingAt
          apCategory
          contractAttachedStatus
          id
          invoicingFrequency
          isLongtail
          name
          propertiesCount
          createdAt
          updatedAt
          reconciliationPreference
          systemProvider
          systemProviderComment
          purchaseOrderRequired
          slug
          status
          registerType
          businessScale
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;

export const QUERY_LANDLORDS_PENDING_COUNT = gql`
  query queryPendingLandlords {
    landlords(statuses: [PENDING]) {
      totalCount
    }
  }
`;

export const QUERY_LANDLORD_NAMES = gql`
  query search($query: String, $pageNumber: Int, $pageSize: Int) {
    search(
      query: $query
      pageSize: $pageSize
      pageNumber: $pageNumber
      publishedStatus: PUBLISHED
    ) {
      totalCount
      edges {
        node {
          ... on Landlord {
            type: __typename
            slug
            name
            id
          }
        }
      }
    }
  }
`;

export const UPDATE_LANDLORD_LINKS = gql`
  mutation operateLandlordLink($input: OperateLandlordLinkInput!) {
    operateLandlordLink(input: $input) {
      result
    }
  }
`;
